module.exports = __webpack_public_path__ + "img/03-pic.3da54f34.png";